import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Routes, Navigate, useLocation, useNavigationType } from 'react-router-dom';
import { CookiesProvider } from 'react-cookie';
import { AnimatePresence, motion } from 'framer-motion';
import { ThemeProvider } from './contexts/ThemeContext';
import StockMainPage from './components/StockMainPage';
import StockDetailPage from './components/StockDetailPage';
import CommunityPage from './components/Community/CommunityPage';
import Login from './components/OAuth/Login';
import ProfilePage from './components/Profile/ProfilePage';
import ArticlePage from './components/Article/ArticlePage';

const pageVariants = {
  initial: (isBack) => ({
    x: isBack ? '-25%' : '100%',
    opacity: isBack ? 0.7 : 0,
  }),
  animate: {
    x: 0,
    opacity: 1,
    transition: {
      x: {
        type: 'tween',
        duration: 0.38,
        ease: [0.25, 0.46, 0.45, 0.94],
      },
      opacity: {
        duration: 0.3,
        ease: [0.25, 0.46, 0.45, 0.94],
      },
    },
  },
  exit: (isBack) => ({
    x: isBack ? '100%' : '-25%',
    opacity: isBack ? 0 : 0.7,
    transition: {
      x: {
        type: 'tween',
        duration: 0.38,
        ease: [0.25, 0.46, 0.45, 0.94],
      },
      opacity: {
        duration: 0.3,
        ease: [0.25, 0.46, 0.45, 0.94],
      },
    },
  }),
};

// 애니메이션 div: overflow: hidden → GPU 컴포지터 레이어 분리 가능
const pageStyle = {
  position: 'fixed',
  inset: 0,
  overflow: 'hidden',
  backgroundColor: 'transparent',
  zIndex: 1,
  willChange: 'transform', // GPU 레이어 미리 승격
};

// 스크롤은 내부 div가 담당
const scrollStyle = {
  height: '100%',
  overflowY: 'auto',
  overflowX: 'hidden',
  WebkitOverflowScrolling: 'touch', // iOS 모멘텀 스크롤
};

const Wrap = ({ children, isBack }) => (
  <motion.div
    custom={isBack}
    variants={pageVariants}
    initial="initial"
    animate="animate"
    exit="exit"
    style={pageStyle}
  >
    <div style={scrollStyle}>
      {children}
    </div>
  </motion.div>
);

const AnimatedRoutes = () => {
  const location = useLocation();
  const navType = useNavigationType();
  const isBack = navType === 'POP';

  return (
    <AnimatePresence mode="sync" initial={false} custom={isBack}>
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Navigate to="/stockMain" />} />
        <Route path="/stockMain" element={<Wrap isBack={isBack}><StockMainPage /></Wrap>} />
        <Route path="/stockDetail/:stockName" element={<Wrap isBack={isBack}><StockDetailPage /></Wrap>} />
        <Route path="/community" element={<Wrap isBack={isBack}><CommunityPage /></Wrap>} />
        <Route path="/profile" element={<Wrap isBack={isBack}><ProfilePage /></Wrap>} />
        <Route path="/login" element={<Wrap isBack={isBack}><Login /></Wrap>} />
        <Route path="/article" element={<Wrap isBack={isBack}><ArticlePage /></Wrap>} />
      </Routes>
    </AnimatePresence>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ThemeProvider>
    <CookiesProvider>
      <BrowserRouter>
        <AnimatedRoutes />
      </BrowserRouter>
    </CookiesProvider>
  </ThemeProvider>
);

reportWebVitals();
